import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocalizedTextFields } from './LocalizedTextFields';

interface PackageIntroFieldsProps {
  descriptionEn: string;
  descriptionVi: string;
  highlightsEn: string;
  highlightsVi: string;
  onDescriptionChange: (next: { en: string; vi: string }) => void;
  onHighlightsChange: (next: { en: string; vi: string }) => void;
  disabled?: boolean;
}

export const PackageIntroFields: React.FC<PackageIntroFieldsProps> = ({
  descriptionEn,
  descriptionVi,
  highlightsEn,
  highlightsVi,
  onDescriptionChange,
  onHighlightsChange,
  disabled = false,
}) => {
  return (
    <Box className="space-y-3 rounded-lg border border-slate-200 p-4 dark:border-slate-700">
      <Box>
        <Typography variant="subtitle1" className="font-semibold text-gray-700 dark:text-slate-300">
          User site intro
        </Typography>
        <Typography variant="body2" className="mt-1 text-gray-600 dark:text-slate-400">
          Shown on the user Subscription page. Enter one language, the other is translated
          automatically — you can edit both.
        </Typography>
      </Box>
      <LocalizedTextFields
        label="Description"
        valueEn={descriptionEn}
        valueVi={descriptionVi}
        onChange={onDescriptionChange}
        multiline
        minRows={2}
        maxLength={1000}
        disabled={disabled}
      />
      <LocalizedTextFields
        label="Highlights"
        helperText="One bullet per line"
        valueEn={highlightsEn}
        valueVi={highlightsVi}
        onChange={onHighlightsChange}
        multiline
        minRows={3}
        maxLength={2000}
        disabled={disabled}
      />
    </Box>
  );
};
